import { Strong } from '@ahmdigital/ui';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.black};
  display: flex;
  flex-direction: column;
  padding: 2rem;
`;

export const LargeDevicePremiumReviewToggleWrapper = styled.div`
  margin-bottom: -3rem;
  margin-left: -1.5rem;
  width: calc(100% + 3rem);
`;

export const StyledStrong = styled(Strong)`
  display: inline-block;
`;
